import styled from 'styled-components';
import { color, spacing } from '../../../theme';

export const StyledContainer = styled.div`
  margin-top: -${spacing('xl4')};
  overflow-x: hidden;
`;

export const StyledWrapper = styled.div`
  background-color: ${color('white')};
`;
